import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import DynamicImage from 'components/DynamicImage'
import SectionWrapper from 'components/SectionWrapper'
import { Text } from 'styles/components/typography'

import { ImageWrapper, ImageBox, Line } from './styles'

/**
 * BHowRegister
 *
 * @param {object} props - properties of component
 * @returns {node} BHowRegister
 */
const BHowRegister = ({ data, index, isSquareHidden, pathCdn }) => {
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper
      isOverflowHidden={true}
      classNameInner="pb-4"
      classNameWrapper="bg--picton-blue"
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.white}
        lineColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1 offset-lg-1 pb-2 pb-md-0">
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
          <ImageBox className="col-12 col-md-6 col-lg-6">
            <ImageWrapper>
              <DynamicImage
                imageSizes={{ xs: 320, md: 237 }}
                image={`${pathCdn}/register/tube-new`}
                imageType="png"
                alt="tube"
                namesByBreakpoints
              />
            </ImageWrapper>
            <Line>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="177"
                height="140"
                viewBox="0 0 177 140"
                fill="none"
              >
                <path
                  stroke="#fff"
                  d="M0 1h70.5c9.941 0 18 8.059 18 18v102c0 9.941 8.059 18 18 18H177"
                />
              </svg>
            </Line>
          </ImageBox>
        </div>
      </HowToBlock>
    </SectionWrapper>
  )
}

BHowRegister.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

BHowRegister.defaultProps = {
  isSquareHidden: false,
}

export default BHowRegister
